import type { ComponentProps } from "react";

import { cn } from "./cn";

const boxClasses = "size-5 shrink-0 rounded-xs border border-input accent-primary";

// A checkbox with `role="switch"` is drawn as a switch: a track (the `input` border colour, 3:1 against the page) and a white thumb. It
// stays a native checkbox, so the form, `checked` and the keyboard work as usual. The position of the thumb and the word on the label say
// the state as well as the colour does.
const switchClasses =
  "relative h-5 w-9 shrink-0 appearance-none rounded-full bg-input transition-colors before:absolute before:top-0.5 before:left-0.5 before:size-4 before:rounded-full before:bg-card before:transition-transform checked:bg-primary checked:before:translate-x-4 forced-colors:appearance-auto forced-colors:before:hidden";

/**
 * A native checkbox (so forms, `checked` and `aria-describedby` behave as in the browser). Put it in a row with a `Label`: the row, not the
 * box, is the 44 px target (see `CheckboxField` in `fields.tsx`).
 */
export function Checkbox({ className, ...props }: ComponentProps<"input">) {
  return (
    <input
      type="checkbox"
      className={cn(
        props.role === "switch" ? switchClasses : boxClasses,
        "cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
